<template>
  <g>
    <path 
      class="c1 c2"
      d="M12,1.25c-3.723,0 -6.75,3.054 -6.75,6.821c0,1.276 0.562,2.859 1.38,4.438c1.801,3.477
      4.801,6.979 4.801,6.979c0.142,0.166 0.35,0.262 0.569,0.262c0.219,-0 0.427,-0.096 0.569,
      -0.262c0,0 3,-3.502 4.801,-6.979c0.818,-1.579 1.38,-3.162 1.38,-4.438c-0,-3.767 -3.027,-6.821
      -6.75,-6.821Zm-0,1.5c2.9,-0 5.25,2.387 5.25,5.321c0,1.466 -0.93,3.376 -2.004,5.157c-1.152,1.91
      -2.5,3.664 -3.246,4.592c-0.746,-0.928 -2.094,-2.682 -3.246,-4.592c-1.074,-1.781 -2.004,-3.691
      -2.004,-5.157c-0,-2.934 2.35,-5.321 5.25,-5.321Z"
      :stroke="iconBorder"
      stroke-width="0"
      :fill="iconColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
    </path>
    <path
      class="c2" 
      d="M12,5.25c-1.518,0 -2.75,1.232 -2.75,2.75c0,1.518 1.232,2.75 2.75,2.75c1.518,0 2.75,
      -1.232 2.75,-2.75c0,-1.518 -1.232,-2.75 -2.75,-2.75Zm0,1.5c0.69,0 1.25,0.56 1.25,1.25c0,0.69
      -0.56,1.25 -1.25,1.25c-0.69,0 -1.25,-0.56 -1.25,-1.25c0,-0.69 0.56,-1.25 1.25,-1.25Z"
      :fill="iconColor"
    >
    </path>
    <path 
      class="c2" 
      d="M16.784,17.377c0.813,0.244 1.483,0.546 1.946,0.9c0.3,0.228 0.52,0.451
     0.52,0.723c-0,0.16 -0.091,0.305 -0.219,0.45c-0.212,0.239 -0.527,0.454
     -0.917,0.654c-1.378,0.705 -3.606,1.146 -6.114,1.146c-2.508,0 -4.736,-0.441
     -6.114,-1.146c-0.39,-0.2 -0.705,-0.415 -0.917,-0.654c-0.128,-0.145 -0.219,-0.29
     -0.219,-0.45c0,-0.272 0.22,-0.495 0.52,-0.723c0.463,-0.354 1.133,-0.656 1.946,-0.9c0.396,-0.119
     0.621,-0.538 0.502,-0.934c-0.119,-0.397 -0.538,-0.622 -0.934,-0.503c-1.238,0.373 -2.2,0.884
     -2.778,1.449c-0.508,0.495 -0.756,1.049 -0.756,1.611c0,0.702 0.397,1.402 1.204,1.986c1.416,1.024
     4.26,1.764 7.546,1.764c3.286,0 6.13,-0.74 7.546,-1.764c0.807,-0.584 1.204,-1.284 1.204,-1.986c-0,-0.562
     -0.248,-1.116 -0.756,-1.611c-0.578,-0.565 -1.54,-1.076 -2.778,-1.449c-0.396,-0.119 -0.815,0.106
     -0.934,0.503c-0.119,0.396 0.106,0.815 0.502,0.934Z"
      :fill="iconColor"
    >
    </path>
    
      
  </g>
</template>

<script>
export default {
   props: {
    iconColor: {
      type: String,
      required: false,
      default: 'black',
    },
    iconBorder: {
      type: String,
      required: false,
      default: 'black',
    },
   },   
};
</script>

<style scoped>
    path {
        font-family: var(--iconFontFamily);
        font-size: var(--iconFontSize);        
    }

    .c2 {
      fill:var(--iconColor)
    }

    .c1 {
      stroke:var(--iconColor)
    }

    .group:hover .group-hover\:text-hoverIcon  .c2{
      fill:var(--iconHoberColor)
    }

    .group:hover .group-hover\:text-hoverIcon  .c1 {
      stroke:var(--iconHoberColor)
    }
</style>